<!--销售单转采购列表页面-->
<template>
    <div class="business-content-main trans-to-purchase-order">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">销售单号</div>
                <el-input
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.OrderCode"
                    v-filter-special-char="searchData.OrderCode"
                    placeholder="销售单号"
                ></el-input>
                <div class="search-name">客户</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.CName"
                    remote
                    filterable
                    allow-create
                    placeholder="请输入客户名称"
                    :remote-method="searchCustom"
                    v-select-scroll-more="searchCustomLoad"
                >
                    <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                        <div class="name">
                            {{ item.EntpCusName }}
                        </div>
                    </el-option>
                </el-select>
                <div class="search-name">采购状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State" style="width:100px">
                    <el-option v-for="item in orderStates" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">物流状态</div>
                <el-select class="search-item" size="small" v-model="searchData.OState" style="width:120px">
                    <el-option label="未出仓" :value="'0'"></el-option>
                    <el-option label="部分出仓" :value="'1'"></el-option>
                    <el-option label="全部出仓" :value="'2'"></el-option>
                </el-select>
                <div class="search-name" v-if="permission.costPrice_edit">核实状态</div>
                <el-select class="search-item" size="small" v-model="searchData.VerifyState" v-if="permission.costPrice_edit" style="width:100px">
                    <el-option v-for="item in verifyStates" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">业务员</div>
                <el-select v-model="searchData.SId" size="small" class="search-item" filterable clearable placeholder="请选择" style="width:100px">
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div v-if="funcConfig.Result" class="search-name">跟单采购员</div>
                <el-select
                    v-if="funcConfig.Result"
                    v-model="searchData.FollowerId"
                    size="small"
                    class="search-item"
                    filterable
                    clearable
                    placeholder="请选择"
                    style="width:100px"
                >
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">创建日期</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                    <div class="dialog-content" v-if="timeVisible">
                        <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                    </div>
                </el-dialog>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" ref="multipleTable" border style="width: 100%">
                <el-table-column width="200" prop="OrderCode" label="销售单号"></el-table-column>
                <el-table-column prop="EntpCusName" label="客户" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="PaymentName" label="支付状态" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" v-if="permission.costPrice_edit" prop="VerifyStateName" label="核实状态" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120" prop="TotalCost" label="总成本价"></el-table-column>
                <el-table-column width="120" v-if="funcConfig.Result" prop="FollowerName" label="跟单采购员" show-overflow-tooltip></el-table-column>
                <el-table-column prop="StateName" label="采购状态" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SName" label="业务员" show-overflow-tooltip></el-table-column>
                <el-table-column width="160" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="OutWarehouseStateName" label="物流状态" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.costPrice_edit" title="核实成本价" size="mini" type="text" @click="gotoCostVerification(scope.row)">{{
                                permission.costPrice_edit
                            }}</el-button>
                            <el-button v-if="permission.transToPOrder" title="转为采购单" size="mini" type="text" @click="gotoQuickBuy(scope.row)">{{
                                permission.transToPOrder
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        timePicker,
        breadcrumb,
        elTableColumn
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            timeVisible: false,
            searchData: {
                OrderCode: '',
                CName: '',
                EntpCusName: '',
                SId: '',
                FollowerId: '',
                OState: '0',
                StartDate: '',
                EndDate: '',
                State: '0',
                VerifyState: '',
                Page: 1,
                limit: 15
            },
            tableData: [], //列表数据
            tableDataLength: 0,
            permission: {},
            payWayList: [],
            funcConfig: {},
            SIdList: [],
            orderStates: [
                { Text: '全部', Value: '-1' },
                { Text: '未采购', Value: '0' },
                { Text: '部分采购', Value: '1' },
                { Text: '已采购', Value: '2' }
            ],
            verifyStates: [
                { Text: '全部', Value: '-1' },
                { Text: '已核实', Value: '1' },
                { Text: '未核实', Value: '0' }
            ],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    activated() {
        this.doLayout('multipleTable');
    },
    mounted() {
        this.getEntpFuncConfigData();
        this.permission = this.$util.getPermission('transToPurchaseOrder');
        this.getSIdList();
        let i = this.SIdList.findIndex(item => {
            if (item.EmployeeId == this.userMsg.EmployeeId) {
                return true;
            }
        });
        if (i == -1) {
            this.SIdList.push({
                EmployeeId: this.userMsg.EmployeeId,
                EmployeeName: this.userMsg.EmployeeName
            });
        }
        this.searchCustom();
    },
    computed: {},
    watch: {},
    methods: {
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //获取企业的功能设置结果
        getEntpFuncConfigData() {
            this.$util.getSysConfig('xsgdy').then(res => {
                this.funcConfig = res;
                if (res.Result) {
                    this.searchData.FollowerId = this.userMsg.EmployeeId;
                }
                this.getSaleOrderVerifyCostList();
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        //获取销售单转采购的列表
        getSaleOrderVerifyCostList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetSaleOrderVerifyCostList',
                    data: this.searchData,
                    hideLoading: false
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        // 跳转快速采购页面
        gotoQuickBuy(row) {
            this.$router.push(`/purchaseManage/purchaseOrders/easyPurchase_new?type=4&id=${row.EntpCusOId}`);
        },
        // 跳转核实成本价页面
        gotoCostVerification(row) {
            this.$router.push(`/purchaseManage/costVerification?id=${row.EntpCusOId}`);
        },
        resetSearch() {
            this.searchData = {
                OrderCode: '',
                CName: '',
                EntpCusName: '',
                SId: '',
                FollowerId: '',
                StartDate: '',
                OState: '0',
                EndDate: '',
                State: '0',
                VerifyState: '',
                Page: 1,
                limit: this.commonPageSize
            };
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getSaleOrderVerifyCostList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getSaleOrderVerifyCostList();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getSaleOrderVerifyCostList();
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.table-ctn {
    height: calc(100% - 162px);
    overflow-y: auto;
}
.search-item {
    width: 150px;
}
</style>
<style lang="less">
.trans-to-purchase-order {
    .el-table {
        .hover-row > td,
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }
}
</style>
